import { render } from "./paymentDetails.vue?vue&type=template&id=ee704922"
import script from "./paymentDetails.vue?vue&type=script&lang=js"
export * from "./paymentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__